import React from 'react';
import { FaHtml5,FaCss3Alt,FaSass,FaBootstrap,FaPhp,FaReact,FaGithubSquare,FaFigma,FaWordpress,FaShopify } from 'react-icons/fa'
import { SiJavascript,SiGooglechrome,SiStyledcomponents,SiNextdotjs,SiLit,SiTailwindcss } from 'react-icons/si'
import { DiMysql } from 'react-icons/di'
import { BiFileFind } from 'react-icons/bi'
import { BsFillPatchCheckFill } from 'react-icons/bs'
import Fade from 'react-reveal/Fade'
import { HabilitiesContainer, HabilitiesH1, HabilitiesWrapper, 
HabilitiesCard,HabilitiesIcon,HabilitiesH2,HabilitiesH22,HabilitiesParr} from './HabilitiesElements'

const Habilities = () => {
    return (
        <HabilitiesContainer id='Habilities'>
            <HabilitiesH1>
               Habilidades del Jimmy
            </HabilitiesH1>
          <Fade bottom>
          <HabilitiesWrapper>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <FaHtml5 />
                    </HabilitiesIcon>
                    <HabilitiesH2>html 5</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <FaCss3Alt />
                    </HabilitiesIcon>
                    <HabilitiesH2>css 3</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <FaSass />
                    </HabilitiesIcon>
                    <HabilitiesH2>sass</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <SiJavascript />
                    </HabilitiesIcon>
                    <HabilitiesH2>javascript</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <FaBootstrap />
                    </HabilitiesIcon>
                    <HabilitiesH2>Bootstrap</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <FaPhp />
                    </HabilitiesIcon>
                    <HabilitiesH2>php</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <SiStyledcomponents />
                    </HabilitiesIcon>
                    <HabilitiesH22>styled components</HabilitiesH22>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <FaReact />
                    </HabilitiesIcon>
                    <HabilitiesH2>React. js</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <FaGithubSquare />
                    </HabilitiesIcon>
                    <HabilitiesH2>git hub</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <FaFigma />
                    </HabilitiesIcon>
                    <HabilitiesH2>figma</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <FaWordpress />
                    </HabilitiesIcon>
                    <HabilitiesH2>wordpress</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <FaShopify />
                    </HabilitiesIcon>
                    <HabilitiesH2>Shopify</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <DiMysql />
                    </HabilitiesIcon>
                    <HabilitiesH2>mysql</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <SiGooglechrome />
                    </HabilitiesIcon>
                    <HabilitiesH2>Tools Google</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <BiFileFind />
                    </HabilitiesIcon>
                    <HabilitiesH2>seo friendly</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <BsFillPatchCheckFill />
                    </HabilitiesIcon>
                    <HabilitiesH2>optimization web</HabilitiesH2>
                </HabilitiesCard>
            </HabilitiesWrapper>
          </Fade>
            <HabilitiesParr>
                Reforzando estas Habilidades
            </HabilitiesParr>
            <Fade bottom>
            <HabilitiesWrapper>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <SiNextdotjs />
                    </HabilitiesIcon>
                    <HabilitiesH2>Next. js</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <SiLit />
                    </HabilitiesIcon>
                    <HabilitiesH2>Lit Element</HabilitiesH2>
                </HabilitiesCard>
                <HabilitiesCard>
                    <HabilitiesIcon>
                        <SiTailwindcss />
                    </HabilitiesIcon>
                    <HabilitiesH2>Tailwind CSS</HabilitiesH2>
                </HabilitiesCard>
            </HabilitiesWrapper>
            </Fade>
        </HabilitiesContainer>
    )
}

export default Habilities
